import { LunchCategory } from '@hungryroot/icons';
import {
  TagPreference,
  FoodProfileDisclosure,
  ControlTagSwitch,
} from '@hungryroot/page-food-profile';
import { Heading, Paragraph } from '@hungryroot/ramen';
import { type PaginatedCustomerTagListList } from '@hungryroot/rest/api/v2/customers/[id]/tag_groups/[tag_group_id]/tags/get';
import { useTagGroup, tagGroups, useCustomerTagGroup } from '@hungryroot/tags';
import styles from './LunchSection.module.css';

interface LunchSectionProps {
  customerId: number;
}

function getSubtitle(
  tagMap: { [key: number]: string },
  customerTags: PaginatedCustomerTagListList
) {
  const tagNames = customerTags.results
    .filter((tag) => tag.preference === TagPreference.Selected)
    .map((tag) => {
      return tagMap[tag.tag];
    });

  return tagNames?.join(', ');
}

export function LunchSection(props: LunchSectionProps) {
  const { customerId } = props;

  const { data: tagGroupData } = useTagGroup(tagGroups.LunchDishTypes);
  const tagMap = tagGroupData?.tags.reduce(
    (acc, tag) => {
      acc[tag.id] = tag.name;
      return acc;
    },
    {} as Record<number, string>
  );

  const { data: customerTagGroupData } = useCustomerTagGroup(
    tagGroups.LunchDishTypes
  );
  const subtitle =
    tagMap !== undefined && customerTagGroupData !== undefined
      ? getSubtitle(tagMap, customerTagGroupData)
      : undefined;

  return (
    <section className={styles.container}>
      <FoodProfileDisclosure
        title="Lunch Preferences"
        subtitle={subtitle || 'Set your preferences.'}
        icon={<LunchCategory />}
        deepLink="lunch-preferences"
      >
        <Heading variant="H5">Do you like these kinds of lunch meals?</Heading>
        <Paragraph className={styles.text}>
          We’ll use your preferences to suggest meals that suit your tastes.
        </Paragraph>
        <ControlTagSwitch
          customerId={customerId}
          colCount={2}
          tagGroupId={tagGroups.LunchDishTypes}
        />
      </FoodProfileDisclosure>
    </section>
  );
}
